import { createAction, props } from '@ngrx/store';
import { ProfitSharingModel } from '@shared/data-access/models';

export const getDetail = createAction(
  '[Profit Sharing] GET DETAIL',
  props<{ item: ProfitSharingModel }>()
);
